import { getData, putData } from "../api/api";

/**
 * Workspace settings → Data isolation: which field separates the data of the workspace's own end users,
 * so an embedded chatbot only ever answers from the asking user's own rows.
 */

export type IsolationValueSource = "ISOLATION_VALUE" | "EXTERNAL_USER_ID" | "EMAIL";

export type DataIsolationRule = {
  workspaceId: string;
  enabled: boolean;
  field?: string | null;
  adaptorField?: string | null;
  valueSource: IsolationValueSource;
  applyToOpenSearch: boolean;
  applyToAdaptors: boolean;
  description?: string | null;
  /** End users of this workspace, provisioned through an integration. */
  endUserCount: number;
  /** Of those, how many have no value for the rule — their chatbot is refused while it is on. */
  endUsersWithoutValue: number;
};

export type DataIsolationRulePayload = {
  enabled?: boolean;
  field?: string | null;
  adaptorField?: string | null;
  valueSource?: IsolationValueSource;
  applyToOpenSearch?: boolean;
  applyToAdaptors?: boolean;
  description?: string | null;
};

const BASE = "/workspaces/me/data-isolation";

export const dataIsolationService = {
  get: () => getData(BASE) as Promise<DataIsolationRule>,
  update: (payload: DataIsolationRulePayload) => putData(BASE, payload) as Promise<DataIsolationRule>,
};
